import { gql } from "@apollo/client";

export const ORGANIZATION_PARAMETERS = gql`
  query OrganizationParameters($category: String) {
    organizationParameters(category: $category) {
      key
      category
      label
      vendor
      direction
      configKeys
      enabled
      presentConfigKeys
      missingConfigKeys
    }
  }
`;

export const ORGANIZATION_INTEGRATIONS = gql`
  query OrganizationIntegrations($where: OrganizationWhereInput!) {
    organizationIntegrations(where: $where) {
      key
      category
      label
      vendor
      configKeys
      enabled
      selected
      presentConfigKeys
    }
  }
`;

const organizationParameters = {
  ORGANIZATION_PARAMETERS,
  ORGANIZATION_INTEGRATIONS,
};

export default organizationParameters;
